import React from 'react';
import './ManifestLetter.css';
import { about } from '../../../constants';

const ManifestLetter = () => {
    return (
        <section className="manifest-letter-section">
            <div className="manifest-letter-container">
                
                {/* --- LEWA KOLUMNA: List Prezesa --- */}
                <div className="ml-column president-column">
                    <div className="president-content">
                        {about.presidentLetter.content.map((paragraph, index) => (
                            <p key={index} className="president-text">
                                {paragraph}
                            </p>
                        ))}
                        
                        <div className="president-signature-box">
                            <p className="closing">{about.presidentLetter.closing}</p>
                            <h4 className="signature">{about.presidentLetter.signature}</h4>
                            <span className="role">{about.presidentLetter.role}</span>
                        </div>
                    </div>
                </div>

                {/* --- PRAWA KOLUMNA: Manifest --- */}
                <div className="ml-column manifesto-column">
                    <div className="manifesto-box">
                        <h2 className="manifesto-title">{about.manifest.title}</h2>
                        <h3 className="manifesto-subtitle">{about.manifest.subtitle}</h3>
                        
                        <div className="manifesto-beliefs">
                            <p className="beliefs-intro">Wierzymy, że:</p>
                            <ul>
                                {about.manifest.beliefs.map((belief, index) => (
                                    <li key={index}>{belief}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="manifesto-conclusion">
                            {about.manifest.conclusion.map((line, index) => (
                                <p key={index}>{line}</p>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ManifestLetter;